import { formatNumber } from "./BudgetGrid";

export const BUDGET_STATUS = {
    ok: { dot: "bg-green-500", bar: "bg-green-500", stroke: "stroke-green-500", text: "text-green-700", track: "bg-green-100" },
    warn: { dot: "bg-amber-500", bar: "bg-amber-500", stroke: "stroke-amber-500", text: "text-amber-700", track: "bg-amber-100" },
    over: { dot: "bg-red-500", bar: "bg-red-500", stroke: "stroke-red-500", text: "text-red-700", track: "bg-red-100" },
};

export const budgetStatusFor = (pct) => {
    if (pct > 100) return BUDGET_STATUS.over;
    if (pct >= 70) return BUDGET_STATUS.warn;
    return BUDGET_STATUS.ok;
};

export default function BudgetProgressBar({ asignado, pct, consumo = 0, emptyLabel = "—" }) {
    if (asignado <= 0) {
        // Sin presupuesto asignado pero con consumo real: no es "nada", es un gasto
        // sin control — hay que alertarlo en vez de mostrar un guion como si no
        // hubiera pasado nada.
        if (consumo > 0) {
            return (
                <span className="text-xs font-semibold text-red-600 whitespace-nowrap">
                    Sin presupuesto
                </span>
            );
        }
        return <span className="text-xs text-gray-300">{emptyLabel}</span>;
    }
    const status = budgetStatusFor(pct);
    return (
        <div className="flex items-center gap-3">
            <div className={`flex-1 max-w-[140px] h-2 rounded-full overflow-hidden ${status.track}`}>
                <div
                    className={`h-full rounded-full ${status.bar} transition-all duration-300`}
                    style={{ width: `${Math.min(pct, 100)}%` }}
                />
            </div>
            <span className={`text-sm font-semibold tabular-nums w-14 text-right ${status.text}`}>
                {formatNumber(pct).replace(/\.00$/, "")}%
            </span>
        </div>
    );
}
